import type { WorkerPool } from "gatsby-worker"

import type { MessagesFromChild, MessagesFromParent } from "./messaging"

export type GatsbyWorkerPool = WorkerPool<
  typeof import("./child"),
  MessagesFromParent,
  MessagesFromChild
>
